import { checkConditions } from 'modules/questionnaire/checkConditions/checkConditions';

export const conditionChecker = (question, user) => checkConditions(user.condition_profile, question.conditions);
